import Bouncer from 'formbouncerjs/src/js/bouncer/bouncer';
import rules from './form-validation-rules';
import { enableForm } from './form-submit';

const forms = document.querySelectorAll('form');

forms.forEach((form, i) => {
	const options = (form.dataset.formOptions ? JSON.parse(form.dataset.formOptions) : null) || {};
	const id = `form-${i}`;

	form.setAttribute('data-form-id', id);

	// Optionally validate fields on change
	form.addEventListener('change', event => {
		const validationOptions = JSON.parse(event.target.dataset.formValidationOptions || '{}');

		if (validationOptions.onChange && form.Bouncer) {
			form.Bouncer.validate(event.target);
		}
	});

	// Validation
	form.Bouncer = new Bouncer(`[data-form-id="${id}"]`, {
		messageTarget: 'data-form-error',
		customValidations: {
			custom: async field => {
				const validation = field.dataset.formValidation;
				const skipValidation = field.dataset.formValidationRunning;
				const value = field.value;

				if (!validation || !rules[validation] || !value || skipValidation) {
					return Promise.resolve(false);
				}

				field.dataset.formValidationRunning = true;

				const result = await rules[validation](value, {
					field,
					url: '/api/validation/'
				});

				delete field.dataset.formValidationRunning;

				field.dataset.formValidationMessage =
					result.message || result.error || field.dataset.formValidationMessage || '';

				if (typeof result.formattedInput !== 'undefined') {
					field.value = result.formattedInput;

					// Reset file label
					if (field.type === 'file') {
						field.dispatchEvent(new CustomEvent('change'));
					}
				}

				// Bouncer expects `false` for valid fields
				return !result.isValid;
			}
		},
		messages: {
			custom: field => {
				let message = field.dataset.formValidationMessage;

				if (!message) {
					const validation = field.dataset.formValidation;

					message =
						window.LN.i18n[`validation__${validation}`] ||
						window.LN.i18n.validation__default;
				}

				return message;
			},
			missingValue: {
				checkbox: window.LN.i18n.validation__default,
				radio: window.LN.i18n.validation__default,
				select: window.LN.i18n.validation__default,
				'select-multiple': window.LN.i18n.validation__default,
				default: window.LN.i18n.validation__default
			},
			patternMismatch: {
				email: window.LN.i18n.validation__email,
				url: 'Please enter a URL.',
				number: window.LN.i18n.validation__number,
				color: 'Please match the following format: #rrggbb',
				date: window.LN.i18n.validation__date,
				time: 'Please use the 24-hour time format. Ex. 23:00',
				month: 'Please use the YYYY-MM format',
				default: window.LN.i18n.validation__default
			},
			outOfRange: {
				over: window.LN.i18n.validation__number_max,
				under: window.LN.i18n.validation__number_min
			},
			wrongLength: {
				over: 'Please shorten this text to no more than {maxLength} characters. You are currently using {length} characters.',
				under: 'Please lengthen this text to {minLength} characters or more. You are currently using {length} characters.'
			}
		},
		disableSubmit: options.ajax || options.customAjax || options.search
	});

	form.addEventListener('bouncerShowError', event => {
		const textField = event.target.closest('.mdc-text-field');

		if (textField) {
			setImmediate(() => {
				textField.classList.add('mdc-text-field--invalid');
			});
		}
		// Form is disabled on submit to prevent multi-submit
		// We need to re-enable it if the submit was cancelled due to validation issues
		enableForm(form);
	});

	form.addEventListener('bouncerRemoveError', event => {
		const textField = event.target.closest('.mdc-text-field');

		if (textField) {
			textField.classList.remove('mdc-text-field--invalid');
		}
	});
});
